export default __webpack_public_path__ + "static/media/full.3fd9d9f9.png";